import { sagas as reviewsSagas } from './modules/reviews'

export default [...reviewsSagas]
